import { memo } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import { CardData } from '../../../../../types';
import { ImageUploader } from './ImageUploader';
import { ContentInputs } from './ContentInputs';
import { ColorPickersSection } from './ColorPickersSection';
import { LinkSection } from './LinkSection';

interface CardConfigPanelProps {
    cardNum: 1 | 2;
    data: CardData;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: any) => void;
    onImageUpload: (e: React.ChangeEvent<HTMLInputElement>, cardNum: 1 | 2) => void;
    uploading: boolean;
    onRemoveImage: (cardNum: 1 | 2) => void;
    onOpenImageConfig: (cardNum: 1 | 2) => void;
    onOpenPreview?: () => void;
    disabled: boolean;
}

export const CardConfigPanel = memo(({
    cardNum,
    data,
    onChange,
    onImageUpload,
    uploading,
    onRemoveImage,
    onOpenImageConfig,
    onOpenPreview,
    disabled,
}: CardConfigPanelProps) => {
    const cardLabel = cardNum === 1 ? 'Left' : 'Right';

    return (
        <div className="card-config-panel">
            <div className="card-config-header">
                <h4>Card {cardLabel} Configuration</h4>
                {onOpenPreview && (
                    <Tooltip title="Quick Preview" placement="top-end" arrow>
                        <button className="quick-preview-btn-inline" onClick={onOpenPreview}>
                            <VisibilityIcon className="preview-icon" />
                        </button>
                    </Tooltip>
                )}
            </div>

            <div className="card-config-grid">
                <ImageUploader
                    cardNum={cardNum}
                    image={data.image}
                    disabled={disabled}
                    onChange={onChange}
                    onImageUpload={onImageUpload}
                    uploading={uploading}
                    onRemoveImage={onRemoveImage}
                    onOpenImageConfig={onOpenImageConfig}
                />
                <ContentInputs
                    cardNum={cardNum}
                    data={data}
                    disabled={disabled}
                    onChange={onChange}
                />

                <LinkSection
                    cardNum={cardNum}
                    data={data}
                    disabled={disabled}
                    onChange={onChange}
                />
            </div>

            <ColorPickersSection
                cardNum={cardNum}
                data={data}
                disabled={disabled}
                onChange={onChange}
            />
        </div>
    );
});

export { ImageUploader } from './ImageUploader';
export { ContentInputs } from './ContentInputs';
export { ColorPickersSection } from './ColorPickersSection';
export { InputField } from './InputField';
export { ColorPicker } from './ColorPicker';